export enum CustomerConsentOrigin {
    Ecommerce = 1,
    SMS = 2,
}